import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage';
import {rbacActions} from '../../config/rbac/actions';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

// FNP-973: READ-ONLY module — index and detail only. No add and no edit route,
// because the deployed schema has no hosted-zone mutation (writes are FNP-977).
export const HostedZonesLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement rbacAction={rbacActions.ListHostedZones} redirectTo='/dashboard'>
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path=':id'
                element={
                    <AuthorizedRouteElement rbacAction={rbacActions.GetHostedZone} redirectTo='/hosted-zones'>
                        <DetailPage/>
                    </AuthorizedRouteElement>
                }
            />
        </Routes>
    );
};
